import React from 'react';
import '../homeComponents/css/hero.css';

export default function HeroBanner() {
  return (
    <section className="heroContainer home-hero1 heroContainer--inner">
      <div className="heroWrapper">
        <div className="heroLeft">
				  <h1 className="contact-page__title">Get in Touch</h1>
				  <p className="contact-page__intro">
					  Ready to simplify your financial compliance? Contact us today for expert assistance.
				  </p>
        </div>
      </div>
    </section>
  );
}
